<template>
    <v-layout class="my-4 border">
        <v-flex class="pa-2">
            <v-autocomplete
                class="ucFirst body-1 tz-dropdown"
                :value="selectedCountries"
                :items="countriesList"
                :outline="outline"
                :append-icon="appendIcon"
                :aria-label="formattedAriaLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :label="formattedLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                multiple
                small-chips
                :rules="[
                    !required || requiredField()
                ]"
                data-testid="covid-screening-country"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @change="emitValue"
            />
        </v-flex>
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { includes, split, toString, values, without } from 'lodash';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import * as countries from 'i18n-iso-countries';

countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
countries.registerLocale(require('i18n-iso-countries/langs/fr.json'));

export default {
    name: 'covid-screening-country',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            upperLocale: 'upperLocale',
        }),

        appendIcon() {
            return this.withIcon ? '' : '';
        },
        countriesList() {
            return values(countries.getNames(this.locale));
        },
        selectedCountries() {
            if (includes(this.value, ',')) {
                return split(this.value, ',');
            }
            return this.value !== 'null' ? [this.value] : [];
        },
    },
    methods: {
        emitValue(value) {
            const cleanValue = without(value, 'null', '');
            this.$emit('update:value', toString(cleanValue));
        },
    },
};
</script>

<style scoped>
.border::v-deep {
    border: 2px solid var(--v-primary-base)!important;
    border-radius: 4px!important;
}
</style>
